import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Form, Col } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import axios from "axios";
import Select from 'react-select'

export default function CustomerContactsModal(props) {

    const [selectCustomerConfig, setSelectCustomerConfig] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState({});

    const initialValues = {
        name: '',
        email: '',
        tel: '',
        info: '',
    };
    const saveNew = (values) => {
        let body = values;
        body.customer_id = selectedCustomer.value;
        return axios.post(process.env.REACT_APP_API_URL + '/api/contacts', body);
    };
    const updateExisting = (values) => {
        let body = values;
        body.customer_id = selectedCustomer.value;
        return axios.put(process.env.REACT_APP_API_URL + '/api/contacts/' + props.edit, body);
    };


    const fetchAllCustomers = () => {
        axios.get(process.env.REACT_APP_API_URL + '/api/customers').then(({ data }) => {
            mapCustomersForSelect(data);
        }).catch(e => props.onSubmit());
    };
    const fetchEntry = () => {
        axios.get(process.env.REACT_APP_API_URL + '/api/contacts/' + props.edit).then(({ data }) => {
            
            setSelectedCustomer({ label: data.customer_short.name, value: data.customer_short.id })

            formik.setFieldValue('name', (data.data.name == null ? '' : data.data.name));
            formik.setFieldValue('email', (data.data.email == null ? '' : data.data.email));
            formik.setFieldValue('tel', (data.data.tel == null ? '' : data.data.tel));
            formik.setFieldValue('info', (data.data.info == null ? '' : data.data.info));
        }).catch(e => props.onSubmit());
    };
    const deleteData = () => {
        axios.delete(process.env.REACT_APP_API_URL + '/api/contacts/' + props.edit).then((d) => {
            toast.success("Gelöscht");
            props.onSubmit();
        }).catch(e => {
            toast.error("Es ist ein Fehler aufgetreten oder du bist für diese Aktion nicht berechtigt. Versuche es erneut oder wende dich an einen Administrator.", { autoClose: 5500 });
            props.onSubmit();
        });
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            name: Yup.string().required(),
            email: Yup.string(),
            tel: Yup.string(),
            info: Yup.string(),
        }),
        onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {

            setSubmitting(false);
            if (props.edit === 0) {
                saveNew(values).then(d => { toast.success("Gespeichert"); resetForm(); props.onSubmit() }).catch(e => console.log(e));
            } else {
                updateExisting(values).then(d => { toast.success("Gespeichert"); resetForm(); props.onSubmit() }).catch(e => console.log(e));
            }
            setSubmitting(true);

        },
    });


    const mapCustomersForSelect = (data) => {
        let options = data.map((item, i) => {
            return { label: item.name, value: item.id };
        });
        setSelectCustomerConfig(options);
    };

    useEffect(() => {
        fetchAllCustomers();
    }, []);

    useEffect(() => {
        if (props.edit !== 0)
            fetchEntry();
    }, [props.edit]);

    useEffect(() => {
        if (props.edit === 0 && props.customer !== undefined)
            setSelectedCustomer({ label: props.customer.name, value: props.customer.id })
    }, [props.edit, props.customer]);

    const renderForm = () => {
        return <Form onSubmit={formik.handleSubmit} className={`bg-white position-relative`}>
            <Modal.Body>
                <div className="row">
                    <div className="col-xl-6">

                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Kunde</Form.Label>
                                <Select options={selectCustomerConfig} value={selectedCustomer} onChange={(o) => {
                                    setSelectedCustomer(o);
                                }}
                                    classNamePrefix="sl2def"
                                    className={Object.keys(selectedCustomer).length <= 0 && 'select2-has-error'}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    name="name"
                                    value={''}
                                    {...formik.getFieldProps("name")}
                                    isInvalid={formik.errors.name}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>E-Mail</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="E-Mail"
                                    name="email"
                                    value={''}
                                    {...formik.getFieldProps("email")}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Tel</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Tel"
                                    name="tel"
                                    value={''}
                                    {...formik.getFieldProps("tel")}
                                />
                            </Form.Group>
                        </Form.Row>
                    </div>
                    <div className="col-xl-6">
                        <Form.Row style={{ height: '100%' }}>
                            <Form.Group as={Col} className="d-flex flex-column">
                                <Form.Label>Info</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Info"
                                    name="info"
                                    className="flex-grow-1"
                                    value={''}
                                    {...formik.getFieldProps("info")}
                                />
                            </Form.Group>
                        </Form.Row>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="submit">Speichern</Button>
                <Button variant="default " onClick={props.onHide}>Schließen</Button>
            </Modal.Footer>
        </Form>
    }

    const deleteForm = () => {
        return <>
            <Modal.Body>
                <p>Bist du dir sicher dass du diesen Kontakt löschen möchtest?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={deleteData}>Ja, Kontakt löschen</Button>
                <Button variant="default " onClick={props.onHide}>Nein, Kontakt nicht löschen</Button>
            </Modal.Footer>

        </>
    }

    return <>
        <Modal
            show={props.show}
            size={(props.type && props.type === 'delete') ? ' md' : 'xl'}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Kunden Kontakt
                    {
                        (props.type && props.type === 'delete') ? ' löschen' :
                            (props.edit === 0) ? ' erstellen' : ' bearbeiten'
                    }
                </Modal.Title>
            </Modal.Header>
            {(props.type && props.type === 'delete') ? deleteForm() : renderForm()}
        </Modal>
    </>

}